import React, { useState } from 'react'
import { toast } from 'react-toastify'

import { ddPanelMainAccountAPI } from '../../api/services/dd_panel_main_accounts'
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'
import Button from '../../components/common/Button/Button.tsx'
import Card from '../../components/common/Card/Card.tsx'
import Popup from '../../components/common/Popup/Popup.tsx'
import SubAccountsList from '../../components/subAccounts/SubAccountsList/SubAccountsList.tsx'

const SubAccounts = ({ userFromPD3 }: { userFromPD3: boolean }) => {
  const [email, setEmail] = useState('')
  const [showInput, setShowInput] = useState(false)
  const [validated, setValidated] = useState(false)
  const [newAccountCreated, setNewAccountCreated] = useState('')
  const [showPopup, setShowPopup] = useState(false)

  const handleShowInput = () => {
    setShowInput(!showInput)
    setEmail('')
  }

  const handleOnChange = (text: string) => {
    setValidated(validateEmail(text))
    setEmail(text)
  }

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const addNewSubAccount = async (requireCertificate = false) => {
    setShowPopup(false)
    if (!validated) {
      return
    }

    const toastId = toast.loading('Tworzenie konta... Proszę czekać.')
    try {
      setShowInput(false)
      const response = await ddPanelMainAccountAPI.createSubAccount(
        { email, require_certificate: requireCertificate }
      )
      if (response.status === 201) {
        setNewAccountCreated(email)
        toast.update(toastId, {
          render:
            'Konto zostało stworzone. Na podany email przyjdzie wiadomość z hasłem',
          type: 'success',
          isLoading: false,
          autoClose: 4000
        })
      }
    } catch {
      toast.dismiss(toastId)
    }
  }

  return (
    <>
      <Breadcrumbs pageName="Konta podrzędne" breadcrumbs={[]} />

      <div className="flex flex-row align-baseline items-top gap-x-10 pb-5 border-b-gray-300">
        <Button
          variant="filled"
          size="medium"
          color="primary"
          type="button"
          className="min-w-80"
          onClick={handleShowInput}
        >
          {showInput ? 'Anuluj' : 'Chcę utworzyć konto podrzędne'}
        </Button>

        {showInput && (
          <div className="flex flex-row h-10 min-w-125">
            <input
              value={email}
              onChange={(e) => handleOnChange(e.target.value)}
              id="email"
              name="email"
              type="email"
              placeholder="Wprowadź e-mail dla nowego konta"
              className="flex-grow max-w-full "
            />
            <Button
              variant="filled"
              size="medium"
              color="success"
              type="button"
              disabled={!validated}
              onClick={() =>
                userFromPD3 ? setShowPopup(true) : addNewSubAccount()
              }
            >
              {'Utwórz'}
            </Button>
          </div>
        )}

        {userFromPD3 && (
          <Popup
            size={'auto'}
            isVisible={showPopup}
            onClose={() => setShowPopup(false)}
          >
            <p className="text-xl font-bold p-6 uppercase">
              Wybierz rodzaj konta
            </p>
            <p className="text-xl px-6 mb-2">
              Czy użytkownik tego konta musi wykupić szkolenie i uzyskać
              certyfikat z Dietokosmetologii?
            </p>
            <div className="w-full flex justify-end my-8 gap-x-4 px-8">
              <Button
                variant="filled"
                size="medium"
                color="primary"
                type="button"
                onClick={() => addNewSubAccount(false)}
                className="px-4 bg-yellow-500 text-white rounded-md shadow-md hover:bg-gray-400 transition-colors"
              >
                Konto bez szkolenia
              </Button>
              <Button
                variant="filled"
                size="medium"
                color="primary"
                type="button"
                disabled={!validated}
                onClick={() => addNewSubAccount(true)}
                className="px-4 bg-green-700 text-white rounded-md shadow-md hover:bg-green-600 transition-colors"
              >
                Konto z obowiązkiem wykupienia szkolenia
              </Button>
            </div>
          </Popup>
        )}
      </div>

      <Card>
        <Card.Body>
          <SubAccountsList newAccountCreated={newAccountCreated} />
        </Card.Body>
      </Card>
    </>
  )
}

export default SubAccounts
